import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { TextInput, Label, Checkbox } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import moment from 'moment';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import { View } from '@dbk/ui-react-utils';
import Text, { Large } from '@dbk/ui-text';
import InverseProvider from '@dbk/ui-inverse';
import { DOC_UPLOAD } from '../../../constants';

class UploadHistorySearch extends PureComponent {
  constructor(props) {
    super(props);
    const currentDate = moment();
    const lastTwoYrs =  moment().add(-2,'years');
    this.state = {
      value: {
        from: lastTwoYrs,
        to: currentDate
      },
      recordListOffset: 0,
      recordListLimit: 20,
      loadMore: false,
      recordOffsetLimit: 0,
      sortColumn: 'createdTs',
      order: 'desc',
      filterObj: {
        bpId: [],
        contract: [],
        name: [],
        isSelf: false,
        dateRange: null
      },
      page: {
        pageNumber: DOC_UPLOAD.PAGE_NUMBER,
        recordSize: DOC_UPLOAD.RECORD_SIZE
      }
    }
  }

  onChangeRange = (range) => {
    this.setState({
      value: {
        ...Utils.updateRangeWithReset(this.state.value, range)
      }
    });

  };
  onApplyDateChange = () => {
    this.setState(prevState => ({
      filterObj: {
        ...prevState.filterObj,
        dateRange: this.state.value
      }
    }))
    this.onCancel();
    this.datepickerRef.datepicker.closeCalendar();
  }

  onInputChange(e) {
    const { name, value } = e.target;
    this.setState(prevState => ({
      filterObj: {
        ...prevState.filterObj,
        [name]: value === "" ? [] : [value],
        dateRange: this.state.value
      }
    }))
  }

  onSearchHandle() {
    //const { docupload: { getUploadHistory } } = this.props;
    this.props.onSearchHandle(this.state.filterObj, this.state.page);
  }

  onClear() {
    const currentDate = moment();
    const lastTwoYrs =  moment().add(-2,'years');
    this.setState({
      filterObj: {
        bpId: [],
        contract: [],
        name: [],
        isSelf: false,
        dateRange: null
      },
      value: {
        from: lastTwoYrs,
        to: currentDate
      },
    })
  }

  customFooter = () => {
    const { i18n: { messages } } = this.props;
    return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" }} >
      <div className='datepicker-footer-txt'>
        <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
      </div>
      <div className='datepicker-footer-btn'>
        <Button tertiary
          onClick={() => this.onCancel()}
        >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

        <Button
          disabled={!(this.state.value.from && this.state.value.to)}
          onClick={() => this.onApplyDateChange()}
        >{messages['app.chedelivery.reports.apply']}</Button>
      </div>
    </InverseProvider>
  }

  isSelfHandle(e) {
    e.target.checked ? this.setState(prevState => ({
      filterObj: {
        ...prevState.filterObj,
        isSelf: true,
        dateRange: this.state.value
      }
    })) : this.setState(prevState => ({
      filterObj: {
        ...prevState.filterObj,
        isSelf: false,
        dateRange: this.state.value
      }
    }))
  }

  validate = () => {
    const { filterObj: { bpId, contract, name, isSelf, dateRange } } = this.state;
    const validateSearch = bpId.length > 0 || contract.length > 0
      || name.length > 0
    if (validateSearch || isSelf || dateRange) {
      return false;
    }
    return true;
  }

  onCancel = () => {
    this.datepickerRef.datepicker.closeCalendar();
  }


  render() {
    const { i18n: { messages } } = this.props;
    return (
      <div>
        <div className="search-container large-12">
          <div className="search-heading margin-bottom-10">{messages['app.documentUploadHistory.search.SearchHeading']}</div>
          <div>
            <Label className="label-header">{messages['app.documentUploadHistory.search.businessPartner']}</Label>
            <TextInput
              className="columns large-12 margin-bottom-20"
              name="bpId"
              size="large"
              testID="txtInput_uploadHistory_search_bpId_test"
              accessibilityLabel="txtInput_uploadHistory_search_bpId_test"
              value={this.state.filterObj.bpId}
              onChange={(e) => this.onInputChange(e)}
              placeholder={messages['app.documentUploadHistory.search.businessPartner.placeholder']}
              type="text" />
          </div>
          <div>
            <Label className="label-header">{messages['app.documentUploadHistory.search.e-BankingContract']}</Label>
            <TextInput
              className="columns large-12 margin-bottom-20"
              name="contract"
              size="large"
              testID="txtInput_uploadHistory_search_contract_test"
              accessibilityLabel="txtInput_uploadHistory_search_contract_test"
              value={this.state.filterObj.contract}
              onChange={(e) => this.onInputChange(e)}
              placeholder={messages['app.documentUploadHistory.search.e-BankingContract.placeholder']}
              type="text" />
          </div>
          <div>
            <Label className="label-header">{messages['app.documentUploadHistory.search.contractName']}</Label>
            <TextInput
              className="columns large-12 margin-bottom-20"
              name="name"
              size="large"
              testID="txtInput_uploadHistory_search_name_test"
              accessibilityLabel="txtInput_uploadHistory_search_name_test"
              value={this.state.filterObj.name}
              onChange={(e) => this.onInputChange(e)}
              placeholder={messages['app.documentUploadHistory.search.contractName.placeholder']}
              type="text" />
          </div>
          <div className="uploadHistory">
            <Label className="label-header">{messages['app.documentUploadHistory.search.dateRange']}</Label>
            <DatePicker
              testID="datePicker_documentUploadHistory_search_test"
              accessibilityLabel="datePicker_documentUploadHistory_search_test"
              placeholder={messages['app.documentUploadHistory.search.dateRange.placeholder']}
              ref={(ref) => this.datepickerRef = ref}
              showOutsideMonthDays={false}
              enableYearNavigation
              enableRangeSelection
              onChange={this.onChangeRange}
              value={this.state.value}
              startDate={moment().add(-2, 'years')}
              endDate={moment()}
              inputDateFormat={'DD MMM YYYY'}
              selectionStart={this.state.value.from}
              selectionEnd={this.state.value.to}
              renderFooter={() => this.customFooter()} />



          </div>
          <div style={{ marginTop: '20px' }}>
            <Checkbox checked={this.state.filterObj.isSelf} textID="chkBx_uploadHistory_isSelf_test"
              accessibilityLabel="chkBx_uploadHistory_isSelf_test"
              onChange={(e) => this.isSelfHandle(e)}
            />
            <label style={{ marginLeft: '10px' }}>{messages['app.docUploadHistory.isSelf']}</label>
          </div>
          <div>
            <Button
              className=" clear-button large-12"
              tertiary
              size="large"
              testID="btn_doc_upload_history_clear_test"
              onClick={() => this.onClear()}>
              {messages['app.documentUploadHistory.search.ClearButton']}
            </Button>
            <Button
              className="search-button large-12"
              size="large"
              testID="btn_doc_upload_history_search_test"
              disabled={this.validate()}
              onClick={() => this.onSearchHandle()}>
              {messages['app.documentUploadHistory.search.SearchButton']}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    docupload: {
      getUploadHistory: { $call: 'getUploadHistory' }
    }
  },
})(UploadHistorySearch);
